export default "assets/logo-50c63138.png";